var $globalHeader = $(".global-header");

$(window).on("load", function () {
	let headerHeight = $globalHeader.outerHeight();
	$("body").css({
		"--header-height": headerHeight + "px",
	});
	$(window).on("resize", function () {
		let headerHeight = $globalHeader.outerHeight();
		$("body").css({
			"--header-height": headerHeight + "px",
		});
	});

	let headerPositionCss = $globalHeader.css("position");

	if (headerPositionCss === "relative") {
		$globalHeader.sticky({
			top: 0,
			zIndex: 100,
		});
	}
});

$(function () {
	$(window).on("scroll", function () {
		var scrollTop = window.pageYOffset || $(document).scrollTop();
		$globalHeader.toggleClass("scrolling", scrollTop > 0);
	});

	$globalHeader.on("sticky-end", function () {
		$("#sticky-wrapper").css({
			height: headerHeight,
		});
	});

	const menuMapping = new MappingListener({
		selector: ".menu-wrapper",
		mobileWrapper: ".menu-mobile-body",
		mobileMethod: "appendTo",
		desktopWrapper: ".header-right",
		desktopMethod: "prependTo",
		breakpoint: 1025,
	}).watch();

	$(".close-menu-mobile, .menu-mobile-backdrop").on("click", function () {
		$(".menu-mobile").removeClass("show");
		$("body").removeClass("overflow-hidden");
		$(".menu-mobile-backdrop").fadeOut();
	});

	$(".toggle-mega").each(function (index, el) {
		$(el).on("click", function () {
			$(el).next().toggleClass("show");
		});
	});

	$(".close-mega").each(function (index, el) {
		$(el).on("click", function () {
			$(el).parent().removeClass("show");
		});
	});

	$(".menu-toggle").on("click", function () {
		$(".menu-mobile").addClass("show");
		$("body").addClass("overflow-hidden");
		$(".menu-mobile-backdrop").fadeIn();
	});

	$("#header-menu > .menu-item-has-children").each(function (index, el) {
		$(this)
			.find("> a")
			.after('<i class="fa fa-angle-down toggle-sub-menu"></i>');
	});

	$(".toggle-sub-menu").each(function (index, el) {
		$(el).on("click", function () {
			$(el).next().slideToggle();
		});
	});
});
